export default __webpack_public_path__ + "static/media/super.1316c70c.jfif";